import { LANG_RU } from "../constants/common";

export default function(localeName = LANG_RU) {
    return localeName.substring(0, 1).toUpperCase()
    + localeName.substring(1, 2).toLowerCase();
};
